<template>
  <v-tooltip
    location="top"
    max-width="420"
    open-on-focus
  >
    <template #activator="{ props: tooltipProps }">
      <v-icon
        v-bind="tooltipProps"
        :icon="icon"
        :size="size"
        class="info-tooltip__icon"
        color="rgba(0, 0, 0, 0.54)"
        tabindex="0"
        :aria-label="label"
        :aria-describedby="descriptionId"
      />
    </template>
    <!-- 改行を含む説明文をそのまま表示するため text prop ではなく既定スロットを使う。 -->
    <span
      :id="descriptionId"
      class="info-tooltip__text"
    >{{ text }}</span>
  </v-tooltip>
</template>

<script lang="ts">
// Vue 3.4 には useId が無いため、インスタンスごとに一意なIDを自前で採番する。
let sequence = 0;

export const nextDescriptionId = (): string => {
  sequence += 1;

  return `info-tooltip-${sequence}`;
};
</script>

<script setup lang="ts">
withDefaults(
  defineProps<{
    // ツールチップに表示する説明文。業務知識は持たず、呼び出し側から受け取る。
    text: string;
    // アイコン自体の読み上げ文言（例: 「周産期うつの説明」）。
    label: string;
    icon?: string;
    size?: number | string;
  }>(),
  {
    icon: "mdi-information-outline",
    size: 16
  }
);

// aria-describedby でアイコンと説明文を関連付ける（ui-design.md 7）。
const descriptionId = nextDescriptionId();
</script>

<style lang="scss" scoped>
.info-tooltip__icon {
  cursor: help;
  vertical-align: middle;
}

.info-tooltip__text {
  white-space: pre-line;
}
</style>
